<template>
  <div class="w-64 2xl:w-88">
    <div class="flex space-x-2 items-center mb-3">
      <icon
        :name="(isOwner) ? 'file-propriete' : 'file'"
        class="text-pink-600 w-5 h-5"
      />
      <info-bulle-hover
        :name="'filename'+file.id"
        :libelle="filename" 
        :is-display-tooltip="isFilenameTooltipDisplay"
        position="bottom-3 left-0"
      /> 
      <h5 
        @mouseover="isFilenameTooltipDisplay = true"
        @mouseleave="isFilenameTooltipDisplay = false"
        class="text-left text-indigo-600 truncate w-60"
      >
        {{ filename }}
      </h5>
    </div>
    <div 
      :class="'relative h-64 2xl:h-88 rounded-md bg-gray-200'"
      @mouseleave="hideFiligrane(); closeMore();"
      @mouseenter="showFiligrane();"
    >
      <!-- Filigrane -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div 
          class="top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-full rounded-md p-6 z-20 flex justify-center items-center cursor-default" 
          v-if="isFiligrane"
        >
          <!-- Filigrane contents -->
          <div 
            class="absolute right-4 top-4 p-2 cursor-pointer"
            @click.stop="displayMore()"
            v-if="!isMoreDisplayed"
          >
            <icon
              name="more-vertical"
              class="text-white"
            />
          </div>
          <div 
            class="absolute right-6 top-6 flex space-x-3"
            v-if="isMoreDisplayed"
          >
            <div
              class="cursor-pointer"
              v-if="editable && $can(constants.PERMISSION_DEPOT_DOCUMENTS_MOVE)"
              @click.stop="moveFile()"
            >
              <icon
                name="foldermove"
                class="text-white transform"
              />
            </div>
            <div 
              v-if="isAdmin && editable && $can(constants.PERMISSION_DEPOT_DOCUMENTS_SHARE) && !$freeParticulier()"
              class="cursor-pointer"
              @click.stop="addMember()"
            >
              <icon
                name="person-add"
                class="text-white"
              />
            </div>
            <div
              v-if="constants.FILE_TYPES.img.includes(file.type.toLowerCase()) || constants.FILE_TYPES.pdf.includes(file.type.toLowerCase())"
              class="cursor-pointer"
              @click="downloadFile"
            >
              <icon
                name="download"
                class="text-white"
              />
            </div>
            <div 
              v-if="editable && $can(constants.PERMISSION_DEPOT_DOCUMENTS_EDIT)"
              class="cursor-pointer"
              @click.stop="editFile()"
            >
              <icon
                name="edit"
                class="text-white"
              />
            </div>
            <div 
              v-if="editable && $can(constants.PERMISSION_DEPOT_DOCUMENTS_DELETE)"
              class="cursor-pointer"
              @click.stop="deleteFile()"
            >
              <icon
                name="trash-2"
                class="text-white"
              />
            </div>
          </div>

          <div 
            v-if="constants.FILE_TYPES.img.includes(file.type.toLowerCase()) || constants.FILE_TYPES.pdf.includes(file.type.toLowerCase())"
            class="border border-pink-600 rounded-full
                            py-1.5 px-3.5 
                            flex justify-center  
                            text-white text-base 
                            w-max cursor-pointer 
                            transition-all duration-300 hover:bg-white hover:text-indigo-600"
            @click.stop="openFile()"
          >
            Ouvrir le fichier
          </div>
          <!-- <a 
                        v-else
                        class="border border-pink-600 rounded-full
                            py-1.5 px-3.5 
                            flex justify-center  
                            text-white text-base 
                            w-max cursor-pointer 
                            transition-all duration-300 hover:bg-white hover:text-indigo-600"
                            :href="'/'+constants.DISKS.main+'/'+file.full_path"
                            :download="file.name"
                    >
                        Télécharger le fichier
                    </a> -->
          <div
            v-else
            class="border border-pink-600 rounded-full
                            py-1.5 px-3.5 
                            flex justify-center  
                            text-white text-base 
                            w-max cursor-pointer 
                            transition-all duration-300 hover:bg-white hover:text-indigo-600
                            text-center"
            @click="downloadFile"
          >
            Télécharger le fichier
          </div>
          <!-- END Filigrane contents -->
        </div>
      </transition>
      <!-- END Filigrane -->
      <img 
        v-if="constants.FILE_TYPES.img.includes(file.type.toLowerCase())" 
        :src="'/depotdocs/'+file.full_path" 
        class="object-cover w-full h-full rounded-md"
        alt="" 
      >
      <embed 
        v-else-if="constants.FILE_TYPES.pdf.includes(file.type.toLowerCase())" 
        :src="'/depotdocs/'+file.full_path+'#toolbar=0&navpanes=0'" 
        class="w-64 h-64 rounded-md" 
      >
      <div
        v-else-if="constants.FILE_TYPES.doc.includes(file.type.toLowerCase())"
        class="flex items-center justify-center h-full"
      >
        <icon
          name="file-text"
          class="text-indigo-600 w-13 h-16"
        />
      </div>
      <div
        v-else-if="constants.FILE_TYPES.xls.includes(file.type.toLowerCase())"
        class="flex items-center justify-center h-full"
      >
        <icon
          name="bar-chart"
          class="text-teal-600 w-13 h-14"
        />
      </div>
      <div
        v-else-if="constants.FILE_TYPES.ppt.includes(file.type.toLowerCase())"
        class="flex items-center justify-center h-full"
      >
        <icon
          name="monitor"
          class="text-orange-600 w-16 h-15"
        />
      </div>
      <div
        v-else
        class="flex items-center justify-center h-full"
      >
        <icon
          name="file"
          class="text-gray-900 transform scale-150"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './../Icon';
import ListAvatars from './../ListAvatars';
import ClickOutside from 'vue-click-outside';
import Constants from './../../constants';
import InfoBulleHover from './../../components/InfoBulleHover';

export default {
  components:{
    Icon,
    ListAvatars,
    InfoBulleHover,
  },

  props:{
    file:{
      type: Object,
      required:true,
    },

    editable:{
      type:Boolean,
    },

    isAdmin:{
      type:Boolean,
    },

    isOwner:{
      type:Boolean
    },

    inNeopassForm:{
      type:Boolean,
      required:false,
      default:false,
    },
  },

  data(){
    return {
      constants: Constants,

      isMoreDisplayed: false,
      isFiligrane: false,

      isFilenameTooltipDisplay: false,
    };
  },

  mounted(){

  },

  methods:{
    showFiligrane(){
      this.isFiligrane = true;
    },

    hideFiligrane(){
      this.isFiligrane = false;
    },

    displayMore(){
      this.isMoreDisplayed = true;
    },

    closeMore(){
      this.isMoreDisplayed = false;
    },

    openFile(){
      this.$emit('openFile');
    },
        
    downloadFile(){
      this.$emit('downloadFile');
    },

    addMember(){
      this.$emit('addMember');
    },

    editFile(){
      this.$emit('editFile');
    },

    deleteFile(){
      this.$emit('deleteFile');
    },

    moveFile(){
      if(this.editable){
        this.$emit('moveFile');
      }
    },
  },

  computed:{
    filename:{
      get:function(){
        return this.file.name.substring(0, this.file.name.lastIndexOf('.'));
      }
    }
  },

  directives: {
    ClickOutside
  }
};
</script>